import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class DownloadedFileResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'file_name': 'Cuenta corriente - Dunder Mifflin - 2026-10-26.xlsx'
            },
            errors: []
        }
    }

    fileName() {
        return this.content().file_name;
    }
}
